import formMaintenance from './form-maintenance.vue';


// 为组件添加 install 方法，用于按需引入
formMaintenance.install = function (Vue) {
    Vue.component(formMaintenance.name, formMaintenance)
}

export default formMaintenance